import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router";
import { clearSignInReturn, readSignInReturn, rememberSignInReturn, safeSignInReturn } from "@/lib/sign-in-return";

/** Keep the address through Google and a wrong-account/access-recovery visit. */
export function SignInRedirect({ to, returnTo }: { to: string; returnTo: string }) {
  useEffect(() => { rememberSignInReturn(returnTo); }, [returnTo]);
  return <Navigate to={to} state={{ returnTo }} replace />;
}

/** Mounted only after membership resolves. Reading is pure under StrictMode. */
export function SignInReturn({ fallback }: { fallback: string }) {
  const location = useLocation();
  const [target] = useState(() => safeSignInReturn(location.state?.returnTo) ?? readSignInReturn());
  useEffect(clearSignInReturn, []);
  return <Navigate to={target ?? fallback} replace />;
}
